import * as XLSX from "xlsx";

export function downloadReportXlsx({ t, data, monthLabel }) {
  const wb = XLSX.utils.book_new();
  const period = data.period ? `${monthLabel(data.period.from)} — ${monthLabel(data.period.to)}` : "";

  const summary = [
    ["İRA Finans — " + t.rep.title],
    [period],
    [],
    [t.rep.totalIncome, data.total_income],
    [t.rep.totalExpense, data.total_expense],
    [t.rep.totalNet, data.total_income - data.total_expense],
  ];
  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(summary), t.lang === "en" ? "Summary" : "Özet");

  const monthly = [
    [t.lang === "en" ? "Month" : "Ay", t.app.income, t.app.expense, "Net"],
    ...data.monthly.map((m) => [monthLabel(m.month), m.income, m.expense, m.net]),
  ];
  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(monthly), t.rep.monthly.slice(0, 31));

  const expCat = [[t.app.category, t.app.amount], ...data.expense_categories.map((c) => [c.category, c.amount])];
  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(expCat), t.rep.expCat.slice(0, 31));

  const incCat = [[t.app.category, t.app.amount], ...data.income_categories.map((c) => [c.category, c.amount])];
  XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(incCat), t.rep.incCat.slice(0, 31));

  if (data.top_receivables.length) {
    const top = [[t.app.cari, t.app.amount], ...data.top_receivables.map((c) => [c.cari_name, c.amount])];
    XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(top), t.rep.topCari.slice(0, 31));
  }

  XLSX.writeFile(wb, `ira-finans-rapor-${new Date().toISOString().slice(0, 7)}.xlsx`);
}
